<template>
  <div>
    <!-- Payment Registered -->
    <div v-if="invoiceSent">
      <h5>Fakturakopi er sendt på nytt</h5>
      <p class="mt-4">
        Informasjon om detaljer for betaling av faktura {{ invoiceNumber }} er sendt til leietaker på nytt.
      </p>

      <div class="mt-5">
        <button class="btn btn-secondary ml-2" @click="goBackOnParent">Tilbake</button>
      </div>
    </div>
    <!-- / Payment Registered -->

    <!-- Payment not registered -->
    <div v-else>
      <h5>Send fakturakopi</h5>
      <p class="mt-4">Klikk “send fakturakopi” for å sende fakturakopi til leietaker på nytt.</p>

      <div class="mt-4">
        <button class="btn btn-sm btn-primary" @click="sendInvoice">Send fakturakopi</button>
        <button class="btn btn-sm btn-secondary ml-2" @click="goBackOnParent">Tilbake</button>
      </div>
    </div>
    <!-- / Payment not registered -->
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  props: ['landlordId', 'tenancyId', 'orderId', 'invoiceNumber'],
  data() {
    return {
      invoiceSent: false,
    };
  },

  methods: {
    ...mapActions('tenancy', ['postTenancyOrderEmailCopy']),
    async sendInvoice() {
      try {
        await this.postTenancyOrderEmailCopy({
          landlordId: this.landlordId,
          tenancyId: this.tenancyId,
          orderId: this.orderId,
        });
        this.$toast('Sent', 'success');
        this.invoiceSent = true;
      } catch (error) {
        console.error(error);
        this.$toast('Kunne ikke sende faktura.', 'error');
      }
    },

    goBackOnParent() {
      this.$emit('back');
    },
  },
};
</script>
